export type OfficeHost = 'excel' | 'other' | 'not_in_office' | 'unknown';

const OFFICE_JS_URL = 'https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js';

export function isLikelyOfficeAddin(): boolean {
  const href = window.location.href;
  if (href.includes('_host_Info')) return true;

  if (window.self !== window.top) {
    const ref = document.referrer;
    if (
      ref.includes('officeapps.live.com') ||
      ref.includes('office.com') ||
      ref.includes('office365.com')
    ) {
      return true;
    }
  }

  return false;
}

let officeJsPromise: Promise<void> | null = null;

export function loadOfficeJs(): Promise<void> {
  const maybeOffice = (globalThis as { Office?: typeof Office }).Office;
  if (maybeOffice?.onReady) return Promise.resolve();

  if (!officeJsPromise) {
    officeJsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = OFFICE_JS_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Office.js'));
      document.head.appendChild(script);
    });
  }

  return officeJsPromise;
}

export async function resolveOfficeHost(): Promise<Exclude<OfficeHost, 'unknown'>> {
  if (!isLikelyOfficeAddin()) {
    return 'not_in_office';
  }

  try {
    await loadOfficeJs();
  } catch {
    return 'not_in_office';
  }

  const maybeOffice = (globalThis as { Office?: typeof Office }).Office;
  if (!maybeOffice?.onReady) {
    return 'not_in_office';
  }

  return new Promise((resolve) => {
    let settled = false;
    const timeout = window.setTimeout(() => {
      if (!settled) resolve('not_in_office');
    }, 1200);

    maybeOffice.onReady((info) => {
      settled = true;
      window.clearTimeout(timeout);
      resolve(info.host === maybeOffice.HostType.Excel ? 'excel' : 'other');
    });
  });
}
